import { useEffect, useState } from "react";
import Mascot from "./Mascot";
import ChatBot from "./ZETY-CHATBOT/Chatbot";
import ChatLauncher from "./ZETY-CHATBOT/ChatLauncher";
import { OPEN_CHAT_EVENT } from "./chatBus";

/**
 * variant="mascot"  -> Techizen mascot acts as the chat trigger
 * variant="bubble"  -> floating chat bubble used site-wide
 */
export default function ZetyAI({ variant = "bubble" }) {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => setIsChatOpen((prev) => !prev);

  // Allow the hero mascot (rendered inside the slider) to open this chat.
  useEffect(() => {
    const open = () => setIsChatOpen(true);
    window.addEventListener(OPEN_CHAT_EVENT, open);
    return () => window.removeEventListener(OPEN_CHAT_EVENT, open);
  }, []);

  return (
    <>
      {variant === "mascot" ? (
        !isChatOpen && (
          <Mascot
            message={"Hi 👋\nI'm Techizen AI.\nClick me to chat!"}
            onToggleChat={toggleChat}
          />
        )
      ) : (
        <ChatLauncher isOpen={isChatOpen} onToggleChat={toggleChat} />
      )}

      <ChatBot
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />
    </>
  );
}
